import { useSpecialFunctions } from "../../functions";

const TrackItem = ({
  race,
  track,
  setSelectOption,
  selectOption,
  setRefreshInfo,
  refreshInfo,
  setRefreshEntries,
  refreshEntries,
  setUpcomingRaceSelected,
  setOffRaceSelected,
  setResultsList,
  setReadOnlyResults,
  setSelectAllTickets,
  setSelectedTicketsVoidScore,
}) => {
  const { getHoursMinutes } = useSpecialFunctions();
  let classLi = "";
  if (selectOption.raceID === race.RaceID) {
    classLi = "active";
  }
  let status;

  //Add the race states as appropriate
  if (race) {
    switch (race.RaceStatus) {
      case "O":
        if (race.MTP === -128) {
          status = (
            <span style={{ fontSize: "14px", marginLeft: "60px" }}>
              {getHoursMinutes(race.SystemRaceDateTime)}
            </span>
          );
        } else if (race.MTP === 0) {
          status = (
            <span
              className="badge badge-pill"
              style={{ backgroundColor: "#17a2b8", color: "#fff" }}
            >
              Post
            </span>
          );
        } else if (race.MTP > 0) {
          status = (
            <span style={{ fontSize: "14px", marginLeft: "60px" }}>
              {race.MTP} m
            </span>
          );
        }
        break;
      case "B":
        status = (
          <span
            className="badge badge-pill"
            style={{ backgroundColor: "#808000", color: "#fff" }}
          >
            Off
          </span>
        );
        break;
      case "C":
        status = (
          <span
            className="badge badge-pill"
            style={{ backgroundColor: "#006622", color: "#fff" }}
          >
            Completed
          </span>
        );
        break;
      case "X":
        status = (
          <span
            className="badge badge-pill"
            style={{ backgroundColor: "#660000", color: "#fff" }}
          >
            Cancelled
          </span>
        );
        break;
      default:
    }
  }

  const activate = (id, add = [], remove = []) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.add(...add);
    el.classList.remove(...remove);
  };

  //Carga los entries para cada carrera
  const getEntries = () => {
    setResultsList([]);
    setReadOnlyResults([]);
    setRefreshInfo(!refreshInfo);
    setRefreshEntries(!refreshEntries);

    setSelectOption(
      track.TrackID,
      track.TrackName,
      race.RaceID,
      race.RaceNumber,
      track.TrackCode,
      "open",
      race.RaceStatus,
    );

    setUpcomingRaceSelected(0);
    setOffRaceSelected(0);
    if (race.RaceStatus !== "C" && race.RaceStatus !== "B") {
      activate("home-tab", ["active"]);
      activate("pool-tab", [], ["active"]);
      activate("chart-tab", [], ["active"]);
      activate("results-tab", [], ["active"]);
      activate("scoreUnscore-tab", [], ["active"]);

      activate("home", ["active", "show"]);
      activate("pool", [], ["active", "show"]);
      activate("chart", [], ["active", "show"]);
      activate("results", [], ["active", "show"]);
      activate("scoreUnscore", [], ["active", "show"]);
    }
    setSelectAllTickets(false);
    setSelectedTicketsVoidScore([]);
  };

  return (
    <li
      key={selectOption.raceID}
      className={classLi}
      onClick={() => getEntries()}
    >
      <a className="mr-3">
        <div
          style={{
            display: "inline-block",
          }}
        ></div>
        R{race.RaceNumber}
        <span style={{ float: "right" }}>{status}</span>
      </a>
    </li>
  );
};

export default TrackItem;
